import { filter as filterRx, Observable } from 'rxjs';
import type { QtFilterComponent } from '../components';
import type { FilterOption } from '../models';
import type { QtControlAdapter } from './qt-control-adapter';

/**
 * Persistence-only counterpart to FilterAdapter: saves/restores the filter
 * value (key `psFilters`) but does NOT transform the data pipeline. Use it where
 * filtering is done elsewhere (e.g. a server-side report query) so the filter is
 * remembered across reloads without adding redundant client-side filtering.
 */
export class FilterServerSideAdapter
  implements QtControlAdapter<FilterOption[]>
{
  readonly key = 'psFilters';

  private _suppress = false;

  readonly valueChanges$: Observable<FilterOption[]> =
    this.filterComponent.filterOptionsState$.pipe(
      filterRx(() => !this._suppress)
    );

  constructor(readonly filterComponent: QtFilterComponent) {}

  applyValue(value: FilterOption[]): void {
    this._suppress = true;
    this.filterComponent.filterOptionsState$.next(value ?? []);
    this._suppress = false;
  }

  getValue(): FilterOption[] {
    return this.filterComponent.filterOptionsState$.getValue();
  }
}
